export default "__VITE_ASSET__Dho2d5f3__"